/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для рендеринга заголовков на странице с фильтрами
   */
  app.Filters.HeaderView = app.View.extend({
    selectClass: false,
    templateId: '',
    events: {
      'click .js-open-filters-popup': 'openCategoryFiltersPopup',
    },
    additionalOptions: [
      'selectClass',
      'chosenFilters',
      'templateId',
      'filters',
      'withCategoriesPopup',
    ],
    /**
     * @inheritDoc
     */
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate(this.templateId);
      this.render();
      if (this.collection !== 'undefined') {
        this.listenTo(Backbone, 'parseFilterData', this.render);
      }
      if (this.withCategoriesPopup) {
        this.initPopup();
      }
    },

    /**
     * Инициализация попапа с фильтрами.
     */
    initPopup: function () {
      var $popupElem = $('.js-category-filters-popup');
      if ($popupElem.length) {
        this.childViews.categoriesFilterPopupView = new app.CategoriesFilterPopupView({
          el: $popupElem,
          filters: this.filters,
        });
      }
    },

    /**
     * Собирает данные для заголовка результатов поиска
     * @returns {{query: string, chosenCategoryName: string}|Boolean}
     */
    collectSearchHeaderData: function () {
      if (!this.collection) {
        return false;
      }
      var query = this.collection.query,
        suggestModel = this.collection.suggest,
        categoryFilterValues = [],
        suggest = '';
      var categoryFilter = _.find(this.chosenFilters.models, function (model) {
        return model.get('paramName') === 'category';
      });
      var chosenCategoryName = '';
      if (categoryFilter) {
        categoryFilterValues = categoryFilter.get('values');
        var chosenCategory = _.find(categoryFilterValues, {selected: true});
        chosenCategoryName = chosenCategory ? chosenCategory.name : chosenCategoryName;
      } else {
        categoryFilterValues = _.get(this.filters, 'data.category.values', []);
        if (categoryFilterValues.length === 1) {
          chosenCategoryName = categoryFilterValues[0].name;
        }
      }

      if (suggestModel) {
        var suggestWord = suggestModel.get('word');
        suggest = suggestWord ? suggestWord.replace(/<.*?>/g, '') : suggest;
        this.listenToOnce(this.collection.suggest, 'change:word', this.render);
      }
      query = suggest || query;

      return {
        query: query,
        chosenCategoryName: chosenCategoryName,
        categoryFilterValuesQty: categoryFilterValues.length,
      };
    },

    /**
     * Открывает попап с фильтрами по категориям.
     * @params {Event} event - событие клика по кнопке выбора категории
     * @returns {Boolean} false для отмены распространения события клика по DOM.
     */
    openCategoryFiltersPopup: function (event) {
      this.childViews.categoriesFilterPopupView.popup.open(this.$(event.currentTarget));
      return false;
    },

    /**
     * @inheritDoc
     */
    render: function () {
      var results = this.model.toJSON(),
        hasItems = !!results.count;
      _.merge(results, {
        resultsHeadAlign: hasItems,
      });
      if (typeof this.collection !== 'undefined') {
        var searchData = this.collectSearchHeaderData();
        _.merge(results, {
          article: _.escape(this.collection.query),
          itemNotInStock: this.collection.itemNotInStock,
          query: searchData ? _.escape(searchData.query) : '',
          chosenCategoryName: searchData ? searchData.chosenCategoryName : '',
          noItemsFound: !hasItems,
          categoryNameAsLink: true,
        });
        if (hasItems) {
          Backbone.trigger('common-view-fill');
        } else {
          Backbone.trigger('common-view-clear');
        }
        if (searchData) {
          results.categoryNameAsLink = searchData.categoryFilterValuesQty !== 1;
        }
      }
      if (this.template) {
        this.$el.html(this.template(results));
        if (this.selectClass) {
          this.$el.toggleClass(this.selectClass, this.model.get('selected'));
        }
      }
    }
  });
})();

}.call(window));